import { Box } from "theme-ui";

export default function RotateRightIcon(props) {
  return (
    <Box
      as="svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M57.6926 47.0389C49.1092 52.0059 43.5339 54.8127 34.3333 58.5225V54.408V53.5771L33.5165 53.4249C24.0087 51.6534 15.8422 48.0193 10.0752 43.251C4.30897 38.4833 1 32.6397 1 26.4032C1 24.8165 1.21351 23.2589 1.62543 21.7399C6.68527 31.0005 18.5543 38.0644 33.1502 40.7838L34.3333 41.0042V39.8007V35.5292C42.323 40.564 48.0559 43.308 57.6926 47.0389ZM3.61075 18.1194L3.61074 18.1194L3.34755 17.4793C7.09712 10.5689 15.1278 4.74748 25.6667 1.35623V13.866C18.268 16.1627 11.9184 19.6471 7.26995 23.9616C5.67024 22.0995 4.44056 20.1377 3.61075 18.1194Z"
        fill="black"
        stroke="white"
        strokeWidth="2"
      />
    </Box>
  );
}
